import { themeToCssVars } from './to-css';

export const colors = {
  primary: '347 83% 42%',
  accent: '96 100% 88%',
  background: {
    primary: {
      default: '0 0% 100%',
      black: '330 2% 19%',
    },
  },
  button: {
    primary: {
      backgroundHover: '347 85% 51%',
      borderHover: '347 85% 51%',
      foreground: '347 85% 51%',
      text: '0 0% 100%',
      backgroundDisabled: '0 0% 86%',
      borderDisabled: '0 0% 86%',
    },
    secondary: {
      background: '0 0% 100%',
      backgroundHover: '347, 85%, 51%',
      borderHover: '347 85% 51%',
      foreground: '347 85% 51%',
      border: '347 83% 42%',
      text: '347 83% 42%',
      textHover: '347 85% 51%',
      backgroundDisabled: '0 0% 86%',
      borderDisabled: '0 0% 86%',
    },
  },
  foreground: '330 2% 19%',
  text: {
    white: '0 0% 100%',
  },
  success: '116 78% 65%',
  error: '0 100% 60%',
  warning: '40 100% 60%',
  info: '220 70% 45%',
  contrast: {
    100: '0 0% 93%',
    200: '0 0% 82%',
    300: '0 0% 70%',
    400: '0 0% 54%',
    500: '0 0% 34%',
    510: '330 0% 48%',
  },
  primaryMix: {
    white: {
      75: '347, 83%, 93%',
    },
    black: {
      75: '97.24, 74.36%, 7.65%',
    },
  },
};

export const BaseColors = () => (
  <style data-makeswift="theme-base-colors">{`:root {
      ${themeToCssVars(colors).join('\n')}
    }
  `}</style>
);
